<template>
    <v-app>
      <v-container>
        <v-layout row>
          <v-flex xs12 md3>
            <v-btn class="primary" dark text
                   @click="addNew">新增問題</v-btn>
          </v-flex>
          <v-flex  xs12 md3>
            <v-btn class="success" dark text :loading="saveLoading"
                   @click="clearAll">一鍵回覆</v-btn>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md2>
            <v-select
              :items="getCaseTypes"
              item-text="value"
              item-value="key"
              label="狀態"
              v-model="selectType"
            ></v-select>
          </v-flex>
          <v-flex xs12 md4>
            <v-btn class="primary" dark text
                   @click="saveStatus">變更狀態</v-btn>
            <v-btn class="success" dark text
                   @click="filterStatus">篩選狀態</v-btn>
          </v-flex>
        </v-layout>
        <v-layout>
          <list-editor :column-keys="columnKeys"
                       :items="questions"
                       :total-items="page.totalCount"
                       :loading="loading"
                       :showSearchBar="true"
                       :showAddButton="false"
                       :show-export-button="true"
                       :show-search-date="false"
                       :searchPlaceHolder="`查詢案件編號`"
                       :show-select="true"
                       :selected="selectItems"
                       @selectData="selectData"
                       @searchData="searchData"
                       @reset="resetData"
                       @changePage="changePage"
                       @changeOption="changeOption"
                       @exportData="exportData"></list-editor>

          <!--彈出視窗-->
          <alert-view :visible="messageDialog.visible"
                      :title="messageDialog.title"
                      :content="messageDialog.content"
                      :show-cancel="false"
                      @confirmEvent="messageDialog.visible = false"></alert-view>
        </v-layout>

        <v-dialog v-model="visible"
                  persistent
                  :max-width="width">
          <v-card>
            <v-card-title>
              <span class="title">新增問題</span>
            </v-card-title>
            <v-card-text>
              <v-layout>
                <v-text-field
                  v-model="itemDetail.displayId" label="案件編號"
                  :required="true"></v-text-field>
              </v-layout>
              <v-layout>
                <v-text-field
                  v-model="itemDetail.name" label="姓名"
                  :required="true"></v-text-field>
              </v-layout>
              <v-layout>
                <v-textarea autofocus counter="50" label="問題："
                            v-model="itemDetail.question"></v-textarea>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="red" dark text @click="cancelEvent">取消</v-btn>
              <v-btn class="primary" dark text :loading="saveLoading" :disabled="isSuccess" @click="confirmEvent">確定</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-app>
</template>

<script>
  import {getCurrentDate , exportTxtFile} from '../utils/tool';
  import ListEditor from "../../components/ListEditor";
  import MobileDetect from 'mobile-detect';
  import AlertView from '@/components/AlertView';
  import { mapActions, mapGetters } from 'vuex';
  import NoticeManager from '@/utils/notice_manager';
  const md = new MobileDetect(window.navigator.userAgent);
  export default {
    name: 'QuestionList',
    components: {ListEditor, AlertView},
    data(){
      return {
        selectType: -1,
        visible: false,
        width: md.phone() ? '100%':'70%',
        loading: false,
        saveLoading: false,
        page:{
          index: 1,
          limit: 10,
          totalPage: 0,
          totalCount: 0,
          searchBy: 'displayId',
          searchValue:'',
          sortBy: 'createdDate',
          sortByValue:'DESC'
        },
        questions: [],
        messageDialog: {
          visible: false,
          title: '',
          content: '',
        },
        isSuccess: false,
        itemDetail:{
          displayId:'',
          name:'',
          question:'',
        },
        selectItems:[],
      };
    },
    created(){
      this.loadData();
    },
    computed: {
      ...mapGetters(['getUserInfo']),
      columnKeys() {
        let list =  [
          { value: 'status', text: '狀態', sortable: true  ,required: true, options: this.getCaseTypes},
          { value: 'displayId', text: '案件編號', sortable: true  ,required: true},
          { value: 'name', text: '姓名', sortable: true  ,required: true},
          { value: 'questionData', text: '問題', sortable: true  ,required: true},
          { value: 'createdDate', text: '建立時間', sortable: true  ,required: false , disabled: true },
        ];
        return list;
      },
      getCaseTypes(){
        return [
          {key: -1, value:'全部'},
          {key: 0, value:'待回覆'},
          {key: 1, value:'已回覆'},
          {key: 2, value:'已結案'}
        ];
      },
      isAdmin() {
        return this.getUserInfo.authority === 'admin';
      }
    },
    methods: {
      ...mapActions(['fetchQuestionList','saveQuestionStatus', 'saveAllQuestionStatus','saveCaseQuestion']),
      filterStatus(){ //篩選
        this.page.searchBy = 'status'
        this.page.searchValue = this.selectType;
        this.loadData();
      },
      selectData(list){ // 多選資料
        this.selectItems = list;
        console.log(`selectData ${JSON.stringify(this.selectItems)}`);
      },
      async saveStatus(){
        console.log(`saveStatus ${JSON.stringify(this.selectItems)} / ${this.selectType}`);
        if (this.selectType === -1){
          this.showDialog(true,'提示', '請選擇要變更的狀態');
          return;
        }

        if (this.selectItems.length === 0){
          this.showDialog(true,'提示', '請選擇要變更的案件');
          return;
        }

        const result = await this.saveQuestionStatus({
          type:'multi',
          list: this.selectItems,
          status: this.selectType,
        });

        const saveResult = result.data;
        if (saveResult){
          if (saveResult.statusCode === 0){
            this.selectItems = [];
            NoticeManager.notifyObservers('resetSelectItem');
            this.loadData();
          } else {
            this.showDialog(true , '成功', saveResult.message);
          }
        } else {
          this.showDialog(true , '錯誤', '更新失敗');
        }
      },
      addNew(){
        this.visible = true;
        this.itemDetail = {
          displayId:'',
          name:'',
          question:'',
        };
      },
      async confirmEvent(){
        if (this.itemDetail.displayId === '') {
          this.showDialog(true, '錯誤','請輸入案件編號！');
          return;
        }

        if (this.itemDetail.name === '') {
          this.showDialog(true, '錯誤','請輸入案件姓名！');
          return;
        }

        if (this.itemDetail.question === '') {
          this.showDialog(true, '錯誤','請輸入問題！');
          return;
        }

        if (this.itemDetail.question.length > 300) {
          this.showDialog(true, '錯誤','問題描述不能超過300個字！');
          return;
        }

        this.saveLoading = true;
        const res = await this.saveCaseQuestion({
          caseId: '' ,
          displayId: this.itemDetail.displayId,
          name: this.itemDetail.name,
          question: this.itemDetail.question
        });
        const saveResult = res.data;
        console.log(`save question ${JSON.stringify(saveResult)}`);
        this.saveLoading = false;
        if (saveResult && saveResult.statusCode === 0){
          this.visible = false;
          this.showDialog(true , '儲存成功', saveResult.message);
        } else {
          this.showDialog(true , '錯誤', saveResult ? saveResult.message: '儲存失敗');
        }
      },
      cancelEvent(){
        this.visible = false;
      },
      changePage(item){
        console.log(`changePage == ${JSON.stringify(item)}`);
        this.page.index = item.page;
        this.page.limit = item.rowsPerPage;
        this.loadData();
      },
      async loadData() {
        if (this.selectType === -1){
            this.page.searchBy = '';
            this.page.sortByValue = '';
        }
        const query = {
          index: this.page.index,
          limit: this.page.limit,
          searchBy: this.page.searchBy,
          searchValue: `${this.page.searchValue}`,
          orderBy: this.page.sortBy,
          orderByValue: this.page.sortByValue,
        };
        this.loading = true;
        const results = await this.fetchQuestionList(query);
        this.loading = false;

        const totalCount = results.data.data.header.totalCount;
        const totalPage = results.data.data.header.totalPage;
        console.log(`totalPage ${totalPage} / totalCount ${totalCount}`);
        this.page.totalCount = totalCount;
        this.page.totalPage = totalPage;
        this.questions = results.data.data.list;
      },
      exportData(){

        exportTxtFile(`${getCurrentDate()}案件問題.txt`, this.questions);

      },
      searchData(key){
        this.page.searchValue = key;
        this.loadData();
      },
      resetData(key){
        this.page.searchValue = '';
        this.loadData();
      },
      async changeOption(item){
        console.log(`changeOption ${JSON.stringify(item)}`);
        const result = await this.saveQuestionStatus({
          caseId: item.caseId,
          id: item.id,
          status: item.status,
        });

        const saveResult = result.data;
        if (saveResult){
          if (saveResult.statusCode === 0){
            this.loadData();
          } else {
            this.showDialog(true , '成功', saveResult.message);
          }
        } else {
          this.showDialog(true , '錯誤', '更新失敗');
        }
      },
      showDialog(visible, title, content) {
        this.messageDialog.visible = visible;
        this.messageDialog.title = title;
        this.messageDialog.content = content;
      },
      async clearAll(){
        const result = await this.saveAllQuestionStatus({
          type: 'all',
          status: 1,
        });

        const saveResult = result.data;
        if (saveResult){
          if (saveResult.statusCode === 0){
            this.loadData();
          } else {
            this.showDialog(true , '成功', saveResult.message);
          }
        } else {
          this.showDialog(true , '錯誤', '更新失敗');
        }
      },
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/QuestionList.vue